import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetTodoOverviewPreview } from "widgets/src/WidgetTodoOverview/WidgetTodoOverview";
import { WidgetTodoOverviewPreviewQuery } from "./__generated__/WidgetTodoOverviewPreviewQuery.graphql";

type Props = {
  query: PreloadedQuery<WidgetTodoOverviewPreviewQuery>;
};

export const WIDGET_TODO_OVERVIEW_PREVIEW_QUERY = graphql`
  query WidgetTodoOverviewPreviewQuery(
    $input: PreviewWidgetTodoCategoryOverviewInput!
    $first: Int
    $after: String
    $storecastId: ID!
  ) {
    dashboard(id: $storecastId) {
      previewWidgetTodoCategoryOverview(input: $input) {
        ...WidgetTodoOverviewPreview_widget
      }
    }
  }
`;

export function WATodoCategoryPreview(props: Props) {
  const data = usePreloadedQuery<WidgetTodoOverviewPreviewQuery>(
    WIDGET_TODO_OVERVIEW_PREVIEW_QUERY,
    props.query
  );

  if (!data.dashboard?.previewWidgetTodoCategoryOverview) {
    return null;
  }

  return (
    <WidgetTodoOverviewPreview
      widget={data.dashboard?.previewWidgetTodoCategoryOverview}
      mode="IDLE"
      interactive={false}
    />
  );
}
